import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import { setModalVisiblity as setModalVisiblityAction, setPortalDashboardObject } from "../reducers/portalDashboard";
export { setHelpSectionState, setReduceHeader } from "../reducers/portalDashboard";

export const setModalVisiblity = setModalVisiblityAction;

export function getPortalObject() {
  return (dispatch) => {
    axiosWrapper
      .get(`${getBackendUrl()}/portal/getPortalDashboardObject`)
      .then((res) => {
        if (res.data.status) {
          dispatch(setPortalDashboardObject(res.data.data));
        }
      })
      .catch((err) => console.log("Error in portal dahboard object", err));
  };
}

export async function jiraController(data) {
  const res = await axiosWrapper.post(`${process.env.REACT_APP_CUBE_BACKEND}/jira/jiraController`, data);
  return res;
}
